<template>
  <div class="createPost-container">
    <div class="createPost-main-container">
      <PayCreateMembership1 v-if="membership==1" @checkout="pay"></PayCreateMembership1>
      <PayCreateMembership2 v-if="membership==2" @checkout="pay"></PayCreateMembership2> 
    </div>
  </div>
</template>

<script>

import PayCreateMembership1 from './create_membership1.vue'
import PayCreateMembership2 from './create_membership2.vue'

export default {
  name: 'PayCreate',
  components: { 
    PayCreateMembership1,
    PayCreateMembership2
  },
  created () {
    this.membership = this.$store.state.user.membership;
  },
  data () {
    return {
      membership: 0
    }
  },
  methods: {
    pay(item) {
      this.$router.push({
        name: 'PayCheckout',
        params: {
          item: item
        }
      });
    }
  }
}
</script>
